<template>
  <div class="help">
    <div class="help-content">
      <el-row>
        <h1 style="margin: 20px auto">{{helpContent.title}}</h1>
      </el-row>

      <el-row v-for="(item, index) in helpContent.describe" :key="index">{{item}}</el-row>

      <el-row><h4>{{helpContent.structureTite}}</h4></el-row>
      
      <el-row>
        <span>
          <a
            v-for="(item, index) in helpContent.structure"
            :key="index">{{item}}<br>
          </a>
        </span>
      </el-row>

      <div v-for="(item, index) in helpContent.contents" :key="index">
        <h2 v-if="item.headline">{{item.headline}}</h2>
        <h4 v-if="item.subtitle">{{item.subtitle}}</h4>
        <section v-for="(temp, key) in item.content" :key="key">{{temp}}</section>
        <el-image v-if="showImage(item.imageNum)" :src="contentImages[item.imageNum]"></el-image>
      </div>

    </div>
  </div>
</template>

<script>
import helpContents from '@/config/help';

export default {
  name: 'water-help-en',

  components: {
  },

  created() {
    this.helpContent = helpContents.en;
  },

  mounted() {

  },

  data () {
    return {
      contentImages: [
        require('@/assets/help/en/help_page_en_0.png'),
        require('@/assets/help/en/help_page_en_1.png'),
        require('@/assets/help/en/help_page_en_2.png'),
        require('@/assets/help/en/help_page_en_3.png'),
        require('@/assets/help/en/help_page_en_4.png'),
        require('@/assets/help/en/help_page_en_5.png'),
        require('@/assets/help/en/help_page_en_6.png'),
        require('@/assets/help/en/help_page_en_7.png'),
        require('@/assets/help/en/help_page_en_8.png'),
        require('@/assets/help/en/help_page_en_9.png'),
        require('@/assets/help/en/help_page_en_10.png'),
        require('@/assets/help/en/help_page_en_11.png'),
        require('@/assets/help/en/help_page_en_12.png'),
        require('@/assets/help/en/help_page_en_13.png'),
        require('@/assets/help/en/help_page_en_14.png'),
        require('@/assets/help/en/help_page_en_15.png'),
        require('@/assets/help/en/help_page_en_16.png'),
        require('@/assets/help/en/help_page_en_17.png'),
        require('@/assets/help/en/help_page_en_18.png')
      ],
      helpContent: ''
    }
  },

  methods:{
    showImage(num) {
      if ('undefined' === typeof num) {
        return false;
      }
      return true;
    }
  }
}
</script>

<style>
.help-content {
  width: 62%;
  margin: 20px auto;
}

.help-content img {
  margin: 20px 0 0 0;
}
</style>